// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__7_keO","contentWrapper":"styles_contentWrapper__QIBXW","content":"styles_content__Ful8D"};